<template>
    <div>

        <section class="hero-wrap hero-wrap-2"
            :style="{backgroundImage: 'url(' + $Url + toposobreimg + ')',height: '250px'}">
            <div class="overlay"></div>
            <div class="container">
                <div class="row no-gutters slider-text align-items-center justify-content-center">
                    <div class="col-md-9 text-center">
                        <h1 class="mb-2 bread">{{toposobrenome}}</h1>
                        <p class="breadcrumbs">
                            <span class="mr-2"><a href="/">Home
                                    <i class="ion-ios-arrow-forward"></i></a></span> <span>{{toposobrenome}}
                                <i class="ion-ios-arrow-forward"></i></span>
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="ftco-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <v-select v-model="Ordemselected" @input="MudaOrdem"
                            style="position:relative;z-index:99999999;float:right;width:200px;" :options="Ordenar"
                            :reduce="nome => nome.valor" single-line label="nome" class="style-chooser">
                        </v-select>
                    </div>
                    <div class="col-md-3">
                        <div class="" v-for="segmento in MenuSegmentos" :key="segmento.segmentoProdNivel1Id">
                            <div class="tab__header">
                                <div class="card-header" style="display: inline-flex;width: 100%;">
                                    <a href="#" class="btn btn-link btn-block text-left" style="display: inline-flex;"
                                        @click.prevent="ativa(segmento.segmentoProdNivel1Id)">
                                        <span class="down-Arrow" style="padding-right: 10px;"
                                            v-if="clicado != segmento.segmentoProdNivel1Id" v-show="true">&#9660;</span>
                                        <span class="up-Arrow" style="padding-right: 10px;"
                                            v-if="clicado == segmento.segmentoProdNivel1Id" v-show="true">&#9650;</span>
                                        {{ segmento.nomeSegmento}}

                                    </a>
                                </div>
                            </div>
                            <div class="tab__content p-2" v-if="clicado == segmento.segmentoProdNivel1Id" v-show="true">
                                <div v-for="segmento2 in ValidaSegmento2(segmento.segmentoProdNivel1Id)"
                                    :key="segmento2.segmentoProdNivel2Id">
                                    <a href="" class=""
                                        style="color: #000000;font-size:16px;line-height: 2;padding-left: 15px;"
                                        @click.prevent="FiltraSegmento2(segmento.segmentoProdNivel1Id,segmento2.segmentoProdNivel2Id)">{{segmento2.nomeSegmento}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="row">
                            <div class="col-md-12">
                                <h5 v-if="SegmentoClicado">{{SegmentoClicado}} <span v-if="SubSegmentoClicado!=''">/</span> {{
                                SubSegmentoClicado}}</h5>
                                <h5 v-else>{{ TextoBusca }}</h5>
                                <p v-if="textovazio">
                                   Não foram encontrados produtos para essa pesquisa.
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div v-for="produto in Produtos" :key="produto.produtoId" class="col-md-3 mt-4">
                                <a href="#"
                                    @click="$redirect_reload('/produtoDetalhe/' + produto.produtoId + '/' + (produto.segmentos ? produto.segmentos[0].segmentoProdNivel1.segmentoProdNivel1Id : 0) + '/' + (produto.segmentos ? produto.segmentos[0].segmentoProdNivel2.segmentoProdNivel2Id : 0) + '/' + produto.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))">
                                    <div class="project img d-flex justify-content-center align-items-center"
                                        :style="{ backgroundImage: 'url(' + $Url + produto.imagens[0].urlImg.replace(/ /g, '%20') + ')',backgroundSize:'contain',backgroundRepeat:'no-repeat',border:'1px solid #cccccc' }">
                                    </div>
                                </a>
                                <div class="text text-center">
                                    <a href="#"
                                        @click="$redirect_reload('/produtoDetalhe/' + produto.produtoId + '/' + (produto.segmentos ? produto.segmentos[0].segmentoProdNivel1.segmentoProdNivel1Id : 0) + '/' + (produto.segmentos ? produto.segmentos[0].segmentoProdNivel2.segmentoProdNivel2Id : 0) + '/' + produto.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))"
                                        style="color: #000000;">
                                        {{produto.nomeProduto }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>

</template>

<script>
//import vSelect from 'vue-select';
import { VMoney } from 'v-money'

export default {
    components: {
        // vSelect,
    },
    data() {
        return {
            TextoBusca: this.$route.params.texto,
            active: false,
            clicado: '',
            toposobre: [],
            toposobrenome: '',
            toposobreimg: '',

            segmentoProdNivel1Id: this.$route.params.idcategoria,
            segmentoProdNivel2Id: this.$route.params.idSubsegmento,
            MenuSegmentos: [],
            MenuSegmento: {},
            //MenuSubSegmentos: [],
            Segmentos2: [],
            textovazio:false,

            ProdutosGerais: [],
            Produtos: [],
            ProdutosFiltro: [],
            produto: {},
            ListaEtiquetaImg: [],
            NomeSegmentoFilho: '',
            Ordemselected: 'Ordenar por',
            Ordenar: [
                {
                    nome: "A-Z",
                    valor: 3
                },
                {
                    nome: "Z-A",
                    valor: 4
                }
            ],
            SegselectedNav: 'Escolha Segmento',
            SegMobile: [],
            parcelas: 0,
            parcelasTexto: '',
            bg_imagem: '',
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: true
            },
            fundotela: '',
            SegmentoClicado: '',
            SubSegmentoClicado: '',
        }
    },
    directives: { money: VMoney },
    methods: {
        MudaOrdem() {
            if (this.Ordemselected == 3) {
                this.Produtos.sort(function (a, b) {
                    if (a.nomeProduto > b.nomeProduto) {
                        return 1;
                    }
                    if (a.nomeProduto < b.nomeProduto) {
                        return -1;
                    }
                    return 0;
                });
            } else if (this.Ordemselected == 4) {
                this.Produtos.sort(function (a, b) {
                    if (a.nomeProduto > b.nomeProduto) {
                        return 1;
                    }
                    if (a.nomeProduto < b.nomeProduto) {
                        return -1;
                    }
                    return 0;
                }).reverse();
            } else {
                this.Produtos.sort(function (a, b) {
                    if (a.produtoId > b.produtoId) {
                        return 1;
                    }
                    if (a.produtoId < b.produtoId) {
                        return -1;
                    }
                    return 0;
                }).reverse();
            }

        },
        MudaSegMobile() {
            this.Produtos = this.ProdutosGerais.filter(x => x.visivel && x.segmentos.some(y => y.segmentoProdNivel2.segmentoProdNivel2Id == parseInt(this.SegselectedNav.segmentoProdNivel2Id, 10))).sort(function (a, b) {
                return a.produtoid - b.produtoid
            });
            this.ProdutosFiltro = this.Produtos;
            this.AplicaFiltros();
            this.NomeSegmentoFilho = this.SegselectedNav.nomeSegmento;
            if (this.SegselectedNav.imagens != '') {
                this.bg_imagem = this.SegselectedNav.imagens[0].urlImagem;
            }
            else {
                this.bg_imagem = '';
            }
            this.MudaOrdem();
        },
        CarregaImagemUnica(value) {
            if (value != null) {
                value.sort(function (a, b) {
                    return a.ordem - b.ordem;
                });

                //value.sort(function (a, b) {
                //    if (a.ordem > b.ordem) {
                //        return 1;
                //    }
                //    if (a.ordem < b.ordem) {
                //        return -1;
                //    }
                //    return 0;
                //});
                return this.$Url + value[0].urlImg;
            }
            else {
                return this.$Url + "/imagens/indisponivel.jpg"
            }

        },
        CarregaProdutos(value) {
            this.SegmentoClicado = value.nomeSegmento;
            this.$http
                .get(this.$apiUrl + "/produto/segmentoprodnivel1/" + parseInt(value.segmentoProdNivel1Id, 10))
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2
                    this.Produtos = this.ProdutosGerais.filter(x => x.visivel && x.imagens != null && x.imagens != '').sort(function (a, b) {
                        if (a.produtoId > b.produtoId) {
                            return 1;
                        }
                        if (a.produtoId < b.produtoId) {
                            return -1;
                        }
                        return 0;
                    }).reverse();
                });
        },
        ValidaSegmento2(value) {
            var result = this.Segmentos2.filter(x => x.segmentoProdNivel1 != null && x.segmentoProdNivel1.segmentoProdNivel1Id == value)
            return result.sort(function (a, b) {
                if (a.nomeSegmento > b.nomeSegmento) {
                    return 1;
                }
                if (a.nomeSegmento < b.nomeSegmento) {
                    return -1;
                }
                return 0;
            });
        },
        ativa(value) {
            if (this.clicado == value) {
                this.clicado = '';
            }
            else {
                this.clicado = value;
            }

        },
        FiltraSegmento2(value1, value2) {
            if (value2!=''){
            this.$http
                .get(this.$apiUrl + "/produto/segmentoprodnivel1/" + parseInt(value1, 10))
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2
                    this.Produtos = this.ProdutosGerais.filter(x => x.visivel 
                                                            && x.imagens != null 
                                                            && x.imagens != '' 
                                                            && x.segmentos != '' 
                                                            && x.segmentos.some(y => y.segmentoProdNivel2!=null && y.segmentoProdNivel2.segmentoProdNivel2Id == value2)).sort(function (a, b) {
                        if (a.produtoId > b.produtoId) {
                            return 1;
                        }
                        if (a.produtoId < b.produtoId) {
                            return -1;
                        }
                        return 0;
                    }).reverse();

                    if (this.Produtos != '') {
                        this.SegmentoClicado = this.Produtos[0].segmentos[0].segmentoProdNivel1.nomeSegmento;
                        this.SubSegmentoClicado = this.Produtos[0].segmentos[0].segmentoProdNivel2.nomeSegmento;
                    }
                    else {
                        this.SegmentoClicado = 'Não possui produtos cadastrados.'
                        this.SubSegmentoClicado = '';
                    }
                    const topValue = window.innerWidth <= 768 ? 600 : 150; // Se for celular, usa 600; se for desktop, usa 150
                        window.scrollTo({
                        top: topValue,
                        behavior: 'smooth' // Faz a rolagem ser suave
                        });

                });
            }
            else{
                this.$http
                .get(this.$apiUrl + "/produto/segmentoprodnivel1/" + parseInt(value1, 10))
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2
                    this.Produtos = this.ProdutosGerais.filter(x => x.visivel 
                                                            && x.imagens != null 
                                                            && x.imagens != '' 
                                                            && x.segmentos != '').sort(function (a, b) {
                        if (a.produtoId > b.produtoId) {
                            return 1;
                        }
                        if (a.produtoId < b.produtoId) {
                            return -1;
                        }
                        return 0;
                    }).reverse();

                    if (this.Produtos != '') {
                        this.SegmentoClicado = this.Produtos[0].segmentos[0].segmentoProdNivel1.nomeSegmento;
                        this.SubSegmentoClicado = '';
                    }
                    else {
                        this.SegmentoClicado = 'Não possui produtos cadastrados.'
                        this.SubSegmentoClicado = '';
                    }

                });
            }
        },
        carregaBusca() {
            let _texto = this.TextoBusca.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            this.$http
                .get(this.$apiUrl + "/produto")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2.filter(x => x.visivel && x.imagens != null && x.imagens != '');
                    this.Produtos = this.ProdutosGerais.filter(x => (x.nomeProduto != null &&
                        x.nomeProduto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1)
                        || (x.resuno != null && x.resuno.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1)
                        || (x.descricao != null && x.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1));
                    
                    if (this.Produtos.length === 0){
                        this.textovazio = true;
                    } else{
                        this.textovazio = false;
                    }
                    });
        }
    },
    created() {

        this.$http
            .get(this.$apiUrl + "/institucional/telas/toposobre")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.toposobre = tiu2;

                if (this.toposobre != null) {
                    this.toposobrenome = "Produtos"
                    if (this.toposobre[0].institucionalImg != '') {
                        this.toposobreimg = this.toposobre[0].institucionalImg[0].urlImagem
                    }
                    else {
                        this.toposobreimg = '';
                    }
                }

            });


        this.$http
            .get(this.$apiUrl + "/SegmentoProdNivel1/")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.MenuSegmentos = tiu2.filter(x => x.visivel).sort(function (a, b) {
                    if (a.nomeSegmento > b.nomeSegmento) {
                        return 1;
                    }
                    if (a.nomeSegmento < b.nomeSegmento) {
                        return -1;
                    }
                    return 0;
                });

                if (typeof this.$route.params.texto == 'undefined' && typeof this.$route.params.idcategoria == 'undefined') {
                    this.FiltraSegmento2(this.MenuSegmentos[0].segmentoProdNivel1Id, '')
                }

                
                if (typeof this.$route.params.idcategoria != 'undefined') {
                  this.FiltraSegmento2(this.segmentoProdNivel1Id, this.segmentoProdNivel2Id)
                }

                if (this.segmentoProdNivel1Id == 0 && this.segmentoProdNivel2Id == 0){
                    this.$redirect('/')
                }
            });

        this.$http
            .get(this.$apiUrl + "/SegmentoProdNivel2")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.Segmentos2 = tiu2.filter(x => x.visivel)
            });

        if (this.TextoBusca != '') {
            this.carregaBusca();
        }
        else {
            this.FiltraSegmento2(this.MenuSegmentos[0].segmentoProdNivel1Id, '')
        }



    },
    mounted() {

    },
}

</script>

<style scoped>
@import '/css/produtos.css';

ul {
    padding-left: unset;
}

.form-control-sidebar {
    max-width: 80%;
}


.product_item {
    width: 100%;
    /*        background: #FFFFFF;
        box-shadow: 6px 4px 8px #ccc;*/
    padding-top: 130px;
    padding-bottom: 230px;
    transition: all .2s ease-in;
}

/*        .product_item:hover {
            box-shadow: 10px 10px 8px #ccc;
        }*/


.vfigure {
    position: absolute;
    float: left;
    top: 20px;
    height: 40px;
    z-index: 999;
    text-align: center;
}


/********************
    Responsive
    ********************/

/* Smartphones */
@media (max-width:767px) {
    .product_item {
        left: 0px;
    }

    .shop_sorting {
        float: initial;
    }

    .shop {
        background: #FFFFFF;
        padding-top: 20px;
        padding-bottom: 139px;
    }

    .vfigure {
        position: absolute;
        float: left;
        top: 65px;
        height: 40px;
        z-index: 999;
        text-align: center;
    }
}

/* Tudo, menos desktop */
@media (max-width:1199px) {
    .product_item {
        height: min-content;
        padding-top: 60px;
        padding-bottom: 80px;
    }

    .product_price {
        margin-top: 0px;
    }
}

.img-item {
    /*border-radius: 5px;*/
    /*   box-shadow: 1px 1px 10px #303030; */
    height: 260px;
}

.content {
    padding: 10px 5px 10px 5px;
}

/* Smartphones */
@media (max-width:767px) {
    .content {
        padding: 30px 10px 50px 10px;
    }
}

.vsa-item__trigger:focus,
.vsa-item__trigger:hover {
    outline: none;
    background-color: #5423c6 !important;
    color: var(--vsa-bg-color);
}

.card-header {
    padding: 0.5rem 0rem !important;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>



